function Introduction() {
  return (
    <div style={{ height: "80vh", width: "100%" }}>
        <h1>Welcome to the Finance Planning App</h1>
        <h2>Retirement</h2>
        <h2>Investments</h2>
        <h2>Tax</h2>
        <h2>Insurance</h2>
        <h2>Estate</h2>
        <h2>Health</h2>
        <h2>Activities</h2>

    </div>
  );
}
export default Introduction;

